import { Loading } from "components/shared";
import React, { useEffect } from "react";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";

const ChangeFormat = ({ format, ...props }) => {

    const { run, input, writeBackReplace, closeMenu } = useMagicAction(props);

    useEffect(() => {
        run({
            prompt: `Rewrite the following text as a ${format}.\n\nTEXT:\n${input}`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackReplace(asText(r)))
            .finally(closeMenu);
    }, []);

    return (
        <div className="flex items-center justify-center p-4 gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default ChangeFormat;
